import styled from 'styled-components';
import {
  InputBase,
} from '@mui/material';
import colors from '../../../../styles/colors';

const StyledInput = styled(InputBase)`
  width: 100%;
  min-height: 40px;
  height: fit-content;
  display: flex;
  align-items: center;
  background: ${colors.base.alpha};

  &.MuiInputBase-root {
    padding: 8px 12px;
  }
`;

export {
  StyledInput,
};
